import { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import Pagination from "../component/section/pagination";
import Categorie from "../component/sidebar/categorie";
import SearchBar from "../component/sidebar/search";

import { ShopContext } from "../context/ShopContext";

const ShopPage = () => {
  const { products, search, showSearch, currency } = useContext(ShopContext);

  const [filteredProducts, setFilteredProducts] = useState([]);
  const [category, setCategory] = useState([]);
  const [sortType, setSortType] = useState("relevant");

  /* ================= GRID / LIST ================= */
  const gridView = () => {
    document.querySelector(".shop-product-wrap")?.classList.add("grid");
    document.querySelector(".shop-product-wrap")?.classList.remove("list");
  };

  const listView = () => {
    document.querySelector(".shop-product-wrap")?.classList.add("list");
    document.querySelector(".shop-product-wrap")?.classList.remove("grid");
  };

  /* ================= CATEGORY FILTER ================= */
  const toggleCategory = (value) => {
    setCategory((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  /* ================= APPLY FILTER ================= */
  const applyFilter = () => {
    let result = [...products];

    if (showSearch && search) {
      result = result.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (category.length > 0) {
      result = result.filter((item) =>
        category.includes(item.category)
      );
    }

    if (sortType === "low-high") {
      result.sort((a, b) => a.price - b.price);
    } else if (sortType === "high-low") {
      result.sort((a, b) => b.price - a.price);
    }

    setFilteredProducts(result);
  };

  useEffect(() => {
    applyFilter();
  }, [products, search, showSearch, category, sortType]);

  return (
    <Fragment>
      <Header />
      <PageHeader title="SHOP" curPage="Shop" />

      <div className="shop-page padding-top padding-bottom">
        <div className="container">
          <div className="row g-4">

            {/* ================= LEFT SIDEBAR ================= */}
            <div className="col-lg-3 col-md-4 col-12">
              <aside className="shop-sidebar">

                <div className="sidebar-block">
                  <SearchBar />
                </div>

                <div className="sidebar-block">
                  <Categorie
                    onCategoryChange={toggleCategory}
                    activeCategories={category}
                  />
                </div>

              </aside>
            </div>

            {/* ================= PRODUCTS ================= */}
            <div className="col-lg-9 col-md-8 col-12">

              <div className="shop-topbar">
                <p>Showing {filteredProducts.length} Products</p>

                <div className="product-view-mode">
                  <button onClick={gridView}>
                    <i className="icofont-ghost"></i>
                  </button>
                  <button onClick={listView}>
                    <i className="icofont-listine-dots"></i>
                  </button>
                </div>
              </div>

              <div className="shop-product-wrap grid row g-4">
                {filteredProducts.map((product) => (
                  <div className="col-lg-4 col-md-6 col-12" key={product._id}>

                    {/* GRID ITEM */}
                    <div className="product-item">
                      <div className="product-thumb">
                        <img
                          src={product.image?.[0] || "assets/images/shop/placeholder.png"}
                          alt={product.name}
                        />
                        <div className="product-action-link">
                          <Link to={`/shop-single/${product._id}`}>
                            <i className="icofont-eye"></i>
                          </Link>
                          <Link to={`/shop-single/${product._id}`}>
                            <i className="icofont-cart-alt"></i>
                          </Link>
                        </div>
                      </div>

                      <div className="product-content">
                        <h5>
                          <Link to={`/shop-single/${product._id}`}>
                            {product.name}
                          </Link>
                        </h5>
                        <h6>{currency}{product.price}</h6>
                      </div>
                    </div>

                    {/* LIST ITEM */}
                    <div className="product-list-item">
                      <div className="product-thumb">
                        <img
                          src={product.image?.[0] || "assets/images/shop/placeholder.png"}
                          alt={product.name}
                        />
                      </div>
                      <div className="product-content">
                        <h5>
                          <Link to={`/shop-single/${product._id}`}>
                            {product.name}
                          </Link>
                        </h5>
                        <h6>{currency}{product.price}</h6>
                        <p>{product.description}</p>
                      </div>
                    </div>

                  </div>
                ))}
              </div>

             
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default ShopPage;
